import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import {
  PARTNER_TABS,
  activeTabLink,
  tabLabel,
  useInCustomerProfile,
  usePartnerView,
} from "./partnerNav";
import styles from "./styles/PartnerNav.module.css";

/*
  The tab row a partner navigates by, in blue on the page background.

  It is the same four destinations the header's NavBar offers everyone else and
  it navigates the same way (replace: true, so the back button does not walk
  back through every tab). Only the paint is different.

  It gates itself, so a caller can drop it in unconditionally and nothing appears
  for anyone who is not a partner.
*/
export function PageTabs({ standalone = false }) {
  const partnerView = usePartnerView();
  const inCustomerProfile = useInCustomerProfile();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [text, setText] = useState(websiteCurrentLang.content.DublicatedText);
  useEffect(() => {
    setText(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const active = activeTabLink(pathname);

  // The profile has tabs of its own; this strip would be a second set.
  if (!partnerView || inCustomerProfile) return null;

  return (
    <nav
      className={
        standalone ? `${styles.tabs} ${styles.tabs_standalone}` : styles.tabs
      }
    >
      {PARTNER_TABS.map((tab) => (
        <div
          key={tab.key}
          data-toggle="link"
          onClick={() => navigate(tab.link, { replace: true })}
          className={tab.link === active ? styles.tab_selected : styles.tab}
        >
          {tabLabel(text, tab)}
        </div>
      ))}
    </nav>
  );
}
